angular.module('inhouseNoticeView', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/boards/inhouse-notice/inhouse-notice-view/inhouse-notice-view.module.js